import Anchor from "@/components/Anchor";
import Modal from "@/components/Modal";
import { getInstance } from "../../app";
import Fuse from "fuse.js";
import "./style.css";

export default class TechnlogySearch extends Modal {
  static selector = ".technology-search-modal";

  constructor(block) {
    super(block);
    this.block = block;

    this.resultsContainer = this.block.querySelector(
      ".technology-search-modal__results"
    );

    this.noResultsContainer = this.block.querySelector(
      ".technology-search-modal__no-results"
    );
  }

  handleSearch = (e) => {
    const query = e.target.value;

    const results =
      query?.length > 0
        ? this.fuse.search(query).map((entry) => entry.item)
        : this.data;

    if (results.length > 0) {
      // results found
      this.noResultsContainer.classList.add("hidden");
      this.resultsContainer.classList.remove("hidden");
      this.buildRows(results);
    } else if (query === "") {
      // query is an empty string - show all items
      this.buildRows(this.data);
    } else {
      // no results found
      this.resultsContainer.classList.add("hidden");
      this.noResultsContainer.classList.remove("hidden");
    }
  };

  buildRows = (results) => {
    window.App.destroyArea(this.resultsContainer);

    results.forEach((item) => {
      const row = document.createElement("a");
      row.classList.add("technology-search-modal__row");
      row.innerText = item.title;
      row.setAttribute("href", item.url);
      this.resultsContainer.appendChild(row);
    });

    window.App.initArea(this.resultsContainer);
  };

  initFuse = () => {
    this.fuse = new Fuse(this.data, {
      keys: ["title"],
      threshold: 0.1,
      sortFn: (a, b) => a.score < b.score,
    });
  };

  initItems = () => {
    this.data = JSON.parse(this.wheelInstance.block.dataset.searchData);

    this.initFuse();

    this.buildRows(this.data);
  };

  onReady() {
    setTimeout(() => {
      this.wheelInstance = getInstance(document.querySelector(".mind-map"));
      this.initItems();
    }, 200);

    this.input = this.block.querySelector("input");

    this.input.addEventListener("input", this.handleSearch);
  }

  onResize() {}

  onDestroy() {
    if (this.input) {
      this.input.removeEventListener("input", this.handleSearch);
    }
  }
}
